export const  ModalType = {
  privacy: 'privacy',
  terms: 'terms',
  tokusho: 'tokusho',
}